export const colors = {
    primary: '#e31e24',
    primaryLight: '#f44336',
    primaryDark: '#c62828',
    secondary: '#2e7d32',
    secondaryLight: '#4caf50',
    secondaryDark: '#1b5e20',
    success: '#2e7d32',
    warning: '#f57c00',
    error: '#d32f2f',
    info: '#1976d2',
    // Text colors
    textPrimary: '#1f1f1f',
    textSecondary: '#666',
    textLight: '#999',
    textWhite: '#ffffff',
    // Background colors
    backgroundPrimary: '#ffffff',
    backgroundSecondary: '#f8f9fa',
    backgroundDark: '#1f1f1f',
    backgroundLight: '#f5f5f5',
    // Border colors
    borderLight: '#e8e8e8',
    borderMedium: '#d9d9d9',
    borderDark: '#bfbfbf',
    // Shadow colors
    shadowLight: 'rgba(0, 0, 0, 0.1)',
    shadowMedium: 'rgba(0, 0, 0, 0.15)',
    shadowDark: 'rgba(0, 0, 0, 0.2)',
    shadowPrimary: 'rgba(227, 30, 36, 0.3)',
    // Gradient colors
    gradientPrimary: 'linear-gradient(135deg, #e31e24 0%, #c62828 100%)',
    gradientPrimaryHover: 'linear-gradient(135deg, #f44336 0%, #e31e24 100%)',
    gradientSecondary: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
    gradientSecondaryHover: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
    gradientHero: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    // Enhanced gradients for About page
    gradientAbout: 'linear-gradient(135deg, #e31e24 0%, #f44336 25%, #c62828 50%, #e31e24 75%, #f44336 100%)',
    gradientAboutAlt: 'linear-gradient(135deg, #e31e24 0%, #f44336 30%, #c62828 60%, #e31e24 100%)',
    gradientAboutRadial: 'radial-gradient(ellipse at center, #e31e24 0%, #f44336 30%, #c62828 70%, #e31e24 100%)',
    // Enhanced gradients for Contacts page
    gradientContacts: 'linear-gradient(135deg, #e31e24 0%, #f44336 20%, #c62828 40%, #f44336 60%, #e31e24 80%, #f44336 100%)',
    gradientContactsAlt: 'linear-gradient(135deg, #e31e24 0%, #f44336 25%, #c62828 50%, #e31e24 75%, #f44336 100%)',
    gradientContactsRadial: 'radial-gradient(ellipse at center, #e31e24 0%, #f44336 25%, #c62828 50%, #f44336 75%, #e31e24 100%)',
    // Additional gradient variations
    gradientAboutConic: 'conic-gradient(from 0deg at 50% 50%, #e31e24 0deg, #f44336 90deg, #c62828 180deg, #e31e24 270deg, #f44336 360deg)',
    gradientContactsConic: 'conic-gradient(from 45deg at 50% 50%, #e31e24 0deg, #f44336 72deg, #c62828 144deg, #e31e24 216deg, #f44336 288deg, #e31e24 360deg)',
};
